import type { Stats } from './types';

/**
 * The main games' stat formula. IVs are fixed at 31 (no IVs in v1 by decision); EVs default to 0
 * and come from Franchise practice later. Natures are out of v1.
 */
export function statsAtLevel(base: Stats, level: number, evs?: Partial<Stats>): Stats {
  const iv = 31;
  const ev = (k: keyof Stats) => Math.floor((evs?.[k] ?? 0) / 4);
  const other = (b: number, k: keyof Stats) => Math.floor(((2 * b + iv + ev(k)) * level) / 100) + 5;
  return {
    hp: Math.floor(((2 * base.hp + iv + ev('hp')) * level) / 100) + level + 10,
    atk: other(base.atk, 'atk'),
    def: other(base.def, 'def'),
    spa: other(base.spa, 'spa'),
    spd: other(base.spd, 'spd'),
    spe: other(base.spe, 'spe'),
  };
}

/** Stat stage multiplier as in the games: +1 = 1.5x, +2 = 2x, -1 = 0.67x, -2 = 0.5x. */
export function stageMult(stage: number): number {
  const s = Math.max(-6, Math.min(6, stage));
  return s >= 0 ? (2 + s) / 2 : 2 / (2 - s);
}
